import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { isObservable, Observable, of } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { selectCurrentLanguage } from '../../../@store/app.selectors';
import { DictionaryItem } from './models/dictionary-item';

@Pipe({
  name: 'appDictionaryItemTranslate',
  pure: false,
})
export class DictionaryItemTranslatePipe implements PipeTransform {
  constructor(private readonly store: Store) {}

  transform(value: DictionaryItem | Observable<DictionaryItem>): Observable<string> {
    if (value === undefined || value === null) {
      return of('');
    }

    if (isObservable(value)) {
      return value.pipe(
        withLatestFrom(this.store.select(selectCurrentLanguage)),
        map(([val, locale]) => this.translate(locale, val)),
      );
    }

    return this.store.select(selectCurrentLanguage).pipe(map((locale: string) => this.translate(locale, value)));
  }

  private translate(locale: string, value: DictionaryItem): string {
    switch (locale) {
      case 'he':
        return value.localName;
      default:
        return value.internationalName;
    }
  }
}
